import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { SPECIAL_OFFER_CLIENT_STATUS, SPECIAL_OFFER_PREVIEW } from 'src/app/extensions/constants/commonConstants';
import { SpecialOfferAPIService } from 'src/app/extensions/services/api/specialOffer-api.service';
import { of, switchMap } from 'rxjs';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';

@Component({
  selector: 'app-special-offer-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  standalone: false,
})
export class PreviewComponent implements OnInit {
  SPECIAL_OFFER_PREVIEW = SPECIAL_OFFER_PREVIEW;
  selectedTab: string = SPECIAL_OFFER_PREVIEW.INFO;
  specialOfferId: string;
  specialOfferState: any;
  specialOffer: app.models.GetSpecialOfferClientModel;
  SPECIAL_OFFER_STATUS = SPECIAL_OFFER_CLIENT_STATUS;

  constructor(
    private _location: Location,
    private _activatedRoute: ActivatedRoute,
    private _specialOfferAPIService: SpecialOfferAPIService,
    private _fileStoreAPIService: FileStoreAPIService
  ) {}

  ngOnInit(): void {
    this.specialOfferId = this._activatedRoute.snapshot.params['specialOfferId'];

    if (this.specialOfferId) {
      this._specialOfferAPIService
        .getClientSpecialOffer(this.specialOfferId)
        .pipe(
          switchMap(response => {
            if (response.campaignImageStoragePath) {
              this._fileStoreAPIService.getFile(response.campaignImageStoragePath).subscribe((fileContent: string) => {
                this.specialOffer.campaignImageSrc = `data:image/png;base64,${fileContent}`;
              });
            }
            return of(response);
          })
        )
        .subscribe(response => {
          this.specialOffer = {
            ...response,
            startDate: new Date(response.startDate),
            expireAt: new Date(response.expireAt),
          };
        });
    }
  }

  redirectListHandler() {
    this._location.back();
  }

  tabChangeHandler(selectedTab: string) {
    this.selectedTab = selectedTab;
  }
}
